import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterBAndWIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_b_and_w"}/>
}
